import SmoothScroll from 'smooth-scroll'
import emailObfuscator from './lib/emailObfuscator'
import Header from './component/GHeader'
import Accordion from './component/Accordion'
import './component/Dialog'

// console.log(window.btoa(unescape(encodeURIComponent('minamoto@wordpress.localhost'))))
emailObfuscator({
	b64: 'bmFrYW11cmFAbmV4dC1mb3JjZS5jb20=',
	selector: '.mailto'
})

// https://github.com/cferdinandi/smooth-scroll
new SmoothScroll('a[href*="#"]', {
	// speed: 1000,
	// speedAsDuration: true,
	updateURL: false,
})
new Header()
document.querySelectorAll('.accordion').forEach(a => new Accordion(a))

// let bannerLine = document.querySelector('.banner-line')
// if (bannerLine) {
// 	bannerLine.addEventListener('click', (e) => {
// 		if (window.innerWidth < 1024) return;
// 		e.preventDefault()
// 		window.location = bannerLine.dataset.hrefalt
// 	})
// }
